import { useAuth } from "../../auth/AuthContext";
import SupplierFinanceMePage from "./SupplierFinanceMePage";
import SupplierFinanceOverviewPage from "./SupplierFinanceOverviewPage";

/** /procurement/finance — dual-view dispatcher mirroring finance/FinancePage.tsx
 * on the opposite ledger direction: suppliers (view_own, not internal) get
 * their own account; internal Otkup staff (assigned/all) get the
 * cross-supplier overview. */
export default function SupplierFinancePage() {
  const { hasPermission, state } = useAuth();
  const internal = state.status === "authenticated" && state.user.internal;
  const seesOverview = hasPermission("supplier_finance:view_assigned") || hasPermission("supplier_finance:view_all");
  if (internal && seesOverview) return <SupplierFinanceOverviewPage />;
  return <SupplierFinanceMePage />;
}
